/**
 * @fileoverview The city's power bank deposit, always visible on the
 * inventory page with a button to change it. Ops asked for the amount to be
 * in front of them rather than something set once after an upload and then
 * only reachable "in the back end".
 */
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import SubmitButton from 'Components/Form/SubmitButton'
import { describeHoldSetting } from 'Utils/PowerBanks'

const Card = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 16px;
  border: 1px solid #eceef0;
  border-radius: 4px;
  background: #fff;
  font-family: 'Proxima Nova', sans-serif;

  .label {
    color: #7e8fa5;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }

  .amount {
    font-size: 20px;
    font-weight: 700;
    color: #011533;
  }

  .detail {
    font-size: 13px;
    color: #7e8fa5;
  }

  .action {
    margin-left: auto;
  }
`

const HoldSettingCard = ({ setting, money, loading, onChange }) => {
  const { amount, detail } = describeHoldSetting(setting, money)
  return (
    <Card cypress_id="powerBankHoldSettingCard">
      <div>
        <div className="label">Power bank deposit</div>
        <div className="amount" cypress_id="powerBankHoldSettingAmount">
          {loading ? '…' : amount}
        </div>
        <div className="detail">{detail}</div>
      </div>
      <div className="action">
        <SubmitButton
          value="Change deposit"
          size="medium"
          variant="outlined"
          disabled={loading}
          onClick={onChange}
        />
      </div>
    </Card>
  )
}

HoldSettingCard.propTypes = {
  setting: PropTypes.shape({
    holdRequired: PropTypes.bool,
    holdAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currency: PropTypes.string,
  }),
  money: PropTypes.shape({
    currencySign: PropTypes.string,
    currency: PropTypes.string,
  }),
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
}

HoldSettingCard.defaultProps = {
  setting: null,
  money: {},
  loading: false,
}

export default HoldSettingCard
